import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { ticketsAPI, projectsAPI, employeesAPI } from '../../lib/api';

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  const [projects, setProjects] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [ticketsRes, projectsRes, employeesRes] = await Promise.all([
        ticketsAPI.getAll(),
        projectsAPI.getAll(),
        employeesAPI.getAll()
      ]);
      setTickets(ticketsRes.data);
      setProjects(projectsRes.data);
      setEmployees(employeesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getProjectName = (projectId) => {
    const project = projects.find(p => p.id === projectId);
    return project?.name || '-';
  };

  const getEmployeeName = (employeeId) => {
    const employee = employees.find(e => e.id === employeeId);
    return employee?.name || '-';
  };

  const columns = [
    { key: 'title', label: 'Title' },
    { key: 'project_id', label: 'Project', render: (val) => getProjectName(val) },
    { key: 'assigned_to', label: 'Assigned To', render: (val) => getEmployeeName(val) },
    { key: 'priority', label: 'Priority', type: 'status' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'title', label: 'Ticket Title', required: true, placeholder: 'Enter ticket title' },
    {
      name: 'project_id',
      label: 'Project',
      type: 'select',
      options: projects.map(p => ({ value: p.id, label: p.name })),
    },
    { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Ticket description' },
    {
      name: 'assigned_to',
      label: 'Assigned To',
      type: 'select',
      options: employees.map(e => ({ value: e.id, label: e.name })),
    },
    {
      name: 'priority',
      label: 'Priority',
      type: 'select',
      defaultValue: 'medium',
      options: [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
      ],
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'open',
      options: [
        { value: 'open', label: 'Open' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'resolved', label: 'Resolved' },
        { value: 'closed', label: 'Closed' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await ticketsAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await ticketsAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await ticketsAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Tickets"
      description="Manage support tickets"
      data={tickets}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
      searchField="title"
    />
  );
};

export default Tickets;
